import apiInternal from './servers/apiInternal';

export interface PushResendCallbacksResponse {
  success: boolean;
  data: string[]; // Array simples de IDs
}

const pushResendCallbacks = {
  resendCallbacks: async ({ cnjIds }: { cnjIds: string[] }): Promise<PushResendCallbacksResponse> => {
    const res = await apiInternal.post(`/push/reenviar-callbacks`, {
      cnjIds,
    });
    // O backend retorna { success: true, data: [...] }
    // Garantimos que sempre retornamos no formato esperado
    if (res.data && res.data.success !== undefined && res.data.data) {
      return res.data;
    }
    // Fallback caso a resposta venha em formato diferente
    return {
      success: true,
      data: Array.isArray(res.data) ? res.data : [],
    };
  },
};

export default pushResendCallbacks;

